import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { ProductsTabs } from '@/components/ProductsTabs'
import { ContactCTA } from '@/components/sections/ContactCTA'

export function Products() {
  const { t } = useTranslation()

  return (
    <main>
      <HeroPage
        title={t('products.hero.title')}
        subtitle={t('products.hero.subtitle')}
        backgroundImage="/images/products/header_prodotti.jpg"
        breadcrumb={[{ label: t('nav.products') }]}
      />
      <ProductsTabs />
      <ContactCTA />
    </main>
  )
}
